module.exports = __webpack_public_path__ + "media/radio wettbewerb 2022.b2365d83.mp3";